import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './our-campaigns-grid.component.scss';
var OurCampaignsGrid = /** @class */ (function (_super) {
    tslib_1.__extends(OurCampaignsGrid, _super);
    function OurCampaignsGrid(element) {
        return _super.call(this, element) || this;
    }
    OurCampaignsGrid.prototype.init = function () { };
    OurCampaignsGrid.prototype.bindEvents = function () { };
    return OurCampaignsGrid;
}(Base));
export { OurCampaignsGrid };



//////////////////
// WEBPACK FOOTER
// ./components/our-campaigns-grid/our-campaigns-grid.component.ts
// module id = 425
// module chunks = 0